import React, { useState } from "react";
import { Fade, Stack } from "@mui/material";
import { SegmentSizeTooltip, SegmentSubTitle } from "../SegmentSettings.styled";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { SegmentTitleTextField } from "../../ContentBlocksEditor/children/ContentBlocksHeader/ContentBlocksHeader.styled";
import { useDispatch, useSelector } from "react-redux";
import { getSelectedSegment } from "../../../redux/selectors/segmentBuilderSelectors";
import {
  handleMenuChange,
  pushToHistoryAction,
  setDesignTabTarget,
  updateSegmentValue,
} from "../../../redux/reducers/segmentBuilder";

const SegmentSize = () => {
  const dispatch = useDispatch();
  const selectedSegment = useSelector(getSelectedSegment);

  const handleChange = (event) => {
    const newValue = event.target.value;
    if (newValue <= 100) {
      dispatch(pushToHistoryAction()); // Push the new state to history

      dispatch(
        updateSegmentValue({ id: selectedSegment?.id, value: newValue })
      );
    }
  };

  const handleSegmentSizeClick = () => {
    dispatch(handleMenuChange({ num: 1 })); // Open design tab
    dispatch(setDesignTabTarget("segments")); // Set target to segments tab
  };

  return (
    <Stack
      direction={"row"}
      alignItems={"center"}
      justifyContent={"space-between"}
      onClick={handleSegmentSizeClick}
      sx={{ cursor: "pointer" }}
    >
      <Stack direction={"row"} alignItems={"center"} gap={"15px"}>
        <SegmentSubTitle>Segment Size</SegmentSubTitle>
        <SegmentTitleTextField
          // autoFocus
          variant="standard"
          InputProps={{
            disableUnderline: true,
          }}
          sx={{ width: "56px" }}
          value={selectedSegment?.value}
          name="title"
          onChange={handleChange}
          fullWidth
          fontWeightValue="500"
          fontSizeValue="12px"
          backgroundColor="#F6F7F9"
        />
      </Stack>

      <SegmentSizeTooltip
        title="Adjust the size of the Segment. Default size is 1"
        placement="left"
        arrow
        TransitionComponent={Fade}
        TransitionProps={{ timeout: 600 }}
      >
        <InfoOutlinedIcon sx={{ color: "#123051", cursor: "pointer" }} />
      </SegmentSizeTooltip>
    </Stack>
  );
};

export default SegmentSize;
